<template>
    <Admin
        :title="__('Shipping', null, $page.props.profile_locale)"
    >
    <div class="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 gap-3">
        <div
            class="shadow-md rounded-md overflow-hidden relative group h-32 flex"
            v-for="(item, key) in delivery" :key="key"
        >
            <img :src="item.image" class="h-full p-2 object-contain group-hover:opacity-50 transition duration-300 m-auto" />

            <div class="absolute z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 group-hover:opacity-100 opacity-0 transition duration-300 flex">
                <IconLink
                    class="mx-1 p-1"
                    icon="pencil"
                    :size="30"
                    :href="route('dashboard.admin.shipping.edit', item.id)"
                />
            </div>

            <div class="absolute z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 group-hover:opacity-100 opacity-0 transition duration-300 flex">
            </div>
            <div class="absolute inset-0 z-10 group-hover:bg-gray-900 group-hover:bg-opacity-10 transition duration-300">
                <h2 class="bg-gray-900 text-gray-200 p-1 font-bold">{{ item.name }}</h2>
            </div>
        </div>
    </div>

    <div class="border-t border-gray-300 col-span-full pt-5 mt-5">
        <InputLabel
            :label="__('Price for shipping', null, $page.props.profile_locale)"
            type="number"
            step="0.01"
            :disabled="$page.props.locale == 'pl'"
            class="lg:w-1/3 md:w-1/2 w-full mb-3"
            v-model="form.shipping.price"
        />
        <InputLabel
            :label="__('The minimum amount for free shipping', null, $page.props.profile_locale)"
            type="number"
            step="0.01"
            :disabled="$page.props.locale == 'pl'"
            class="lg:w-1/3 md:w-1/2 w-full mb-3"
            v-model="form.shipping.price_free"
        />
        <InputLabel
            :label="__('Shipping description', null, $page.props.profile_locale) + ' - ' + $page.props.locale.toUpperCase()"
            type="quill"
            class="mt-5"
            v-model="form.shipping.desc"
        />

        <Button
            class="mt-4"
            @click="savePriceShipping"
            :class="[ form.isDirty ? '' : 'opacity-50' ]"
            padding="md"
        >{{ __('Update', null, $page.props.profile_locale) }} </Button>
    </div>

    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import IconLink from 'UI/IconLink';
    import InputLabel from 'UI/InputLabel';
    import Button from 'UI/Button';

import { useForm } from '@inertiajs/inertia-vue3';

    export default {
        props: {
            delivery: [Object, Array],
            options: [Array, Object],
        },
        components: {
            Admin, IconLink, InputLabel, Button
        },

        setup(props) {
            const form = useForm(props.options);

            function savePriceShipping(){
                form.post(route('update.info'), {
                    preserveScroll: true,
                });
            }

            return {
                form,

                savePriceShipping
            }
        }
    }
</script>
